import { Component } from '@angular/core';

@Component({
    selector: 'unathorized-page',
    templateUrl: './unathorized-page.component.html',
    styleUrls: ['./unathorized-page.component.css'],
    standalone: false
})
export class UnathorizedPageComponent {

}
